<template>
  <v-card>
    <v-card-title> Compartilhamento de Simulações </v-card-title>
    <v-card-text v-show="!showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <GraphicColumn
      v-if="showCard"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
      :stacking="stacking"
    />
    <GraphicLine
      v-if="false"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
      :stacking="stacking"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    GraphicColumn: () => import("./GraphicColumn"),
    GraphicLine: () => import("./GraphicLine"),
  },

  data() {
    return {
      categories: [],
      titleY: "Simulações",
      titleX: "Empresa",
      chartSeries: [
        {
          color: "#ea4335",
          data: [],
          name: "Compartilhou Criando Lead",
          showInLegend: true,
        },
        {
          color: "#4285f4",
          data: [],
          name: "Compartilhou",
          showInLegend: true,
        },
      ],
      stacking: true,
      date_init: "",
      date_end: "",
      isCompany: false,
      company: [],
      showCard: false,
    };
  },
  methods: {
    async init() {
      var dataValue = [];
      var dataValueSimulate = [];
      var dataCategorie = [];
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;

      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/simulacoesCompartilhadas");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company,
      })
        .then((result) => {
          var tmp = [];
          this.getEmpresas.forEach((e, c) => {
            tmp = [];
            tmp = result.data.filter((a) => {
              return a.empresa == e.cnpj;
            });
            dataValue.push(
              tmp.length > 0 ? Number(tmp[0].total_compartilhado) : 0
            );
            dataValueSimulate.push(
              tmp.length > 0 ? Number(tmp[0].total_simulado) : 0
            );
            dataCategorie.push(e.apelido);
          });
        })
        .catch((erro) => {
          console.log(erro);
        });

      Promise.all(dataValue, dataCategorie).then((a) => {
        this.showCard = !this.showCard;
        this.categories = dataCategorie;
        this.chartSeries[0].data = dataValue;
        this.chartSeries[1].data = dataValueSimulate;
      });
    },
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"]),
    ...mapGetters(["getEmpresas"]),
  },
  watch: {
    getFilter(m, v) {
      this.showCard = false;
      this.init();
    },
  },
};
</script>

<style lang="scss"></style>
